"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Text_styles_1 = __importDefault(require("./Text.styles"));
function Text(_a) {
    var className = _a.className, _b = _a.component, component = _b === void 0 ? 'div' : _b, children = _a.children, _c = _a.size, size = _c === void 0 ? 'md' : _c, weight = _a.weight, transform = _a.transform, style = _a.style, color = _a.color, align = _a.align, _d = _a.variant, variant = _d === void 0 ? 'text' : _d, themeOverride = _a.themeOverride, elementRef = _a.elementRef, others = __rest(_a, ["className", "component", "children", "size", "weight", "transform", "style", "color", "align", "variant", "themeOverride", "elementRef"]);
    var classes = Text_styles_1.default({ variant: variant, color: color, size: size, theme: theme_1.useMantineTheme(themeOverride) });
    return react_1.default.createElement(component, __assign({ className: clsx_1.default(classes.text, className), style: __assign({ fontWeight: weight, textTransform: transform, textAlign: align }, style), ref: elementRef }, others), children);
}
exports.Text = Text;
Text.displayName = '@mantine/core/Text';
function Anchor(_a) {
    var _b = _a.component, component = _b === void 0 ? 'a' : _b, others = __rest(_a, ["component"]);
    return react_1.default.createElement(Text, __assign({ component: component, variant: "link" }, others));
}
exports.Anchor = Anchor;
Anchor.displayName = '@mantine/core/Anchor';
